module.exports = __webpack_public_path__ + "img/bs_logo.1782730a.png";